import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* Import dependencies for task.js */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addError } from '../actions';
var Expire = /*#__PURE__*/function (_Component) {
  function Expire(props) {
    var _this;
    _classCallCheck(this, Expire);
    _this = _callSuper(this, Expire, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      _this.setTimer();
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.children !== _this.props.children) {
        _this.setTimer();
        _this.setState({
          visible: false
        });
      }
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      clearTimeout(_this._timer);
    });
    _defineProperty(_this, "setTimer", function () {
      // clear any existing timer
      _this._timer != null ? clearTimeout(_this._timer) : null;
      _this.setState({
        visible: true
      }, function () {
        _this._timer = setTimeout(function () {
          _this.setState({
            visible: false
          });
          _this._timer = null;
        }, _this.props.delay);
      });
    });
    _defineProperty(_this, "render", function () {
      return _this.state.visible ? /*#__PURE__*/React.createElement("div", {
        className: "error type-".concat(_this.props.type, " is-visible")
      }, _this.props.children) : null;
    });
    _this.state = {
      delay: 1000,
      visible: true
    };
    return _this;
  }
  _inherits(Expire, _Component);
  return _createClass(Expire);
}(Component);
var Error = /*#__PURE__*/function (_Component2) {
  function Error() {
    var _this2;
    _classCallCheck(this, Error);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Error, [].concat(args));
    _defineProperty(_this2, "error", function (error, i) {
      return /*#__PURE__*/React.createElement(Expire, {
        delay: 5000,
        ref: i,
        key: "error-".concat(i),
        type: error.type ? error.type : 'warning'
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, error.msg));
    });
    return _this2;
  }
  _inherits(Error, _Component2);
  return _createClass(Error, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "error-messages-container"
      }, this.props.errors.map(this.error));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    errors: state.errors
  };
};
var mapDispatchToProps = {
  addError: addError
};
export default connect(mapStateToProps, mapDispatchToProps)(Error);